/**
 * PROTOTYPE – texts not approved
 *
 * Geschichtenschritt round 3 — tile pictograms, inline SVG copied
 * verbatim from the design canvas
 * (`scratch/geschichtenschritt-entwurf.dc.html` lines 73-108).
 *
 * The design canvas file is NOT shipped — we only re-implement the
 * markup in the PWA's component conventions. Pictograms use the
 * Dreamable brand palette (navy / gold / soft-beige / sky-blue /
 * steel) plus the few extra illustration colours already present
 * in the mockup (red #E4572E, green shades, brown).
 */
import type { JSX } from 'react';
import type { ErfundenTileSlug } from '../../state/book-configurator-store';

export function EigeneIdeeIcon(): JSX.Element {
  return (
    <svg width="36" height="36" viewBox="0 0 48 48" aria-hidden="true">
      <path
        d="M24 6a12 12 0 0 0-7.5 21.4c1.6 1.3 2.5 3 2.5 5h10c0-2 .9-3.7 2.5-5A12 12 0 0 0 24 6z"
        fill="#FFC94D"
      />
      <rect x="19" y="34" width="10" height="3" rx="1" fill="#445771" />
      <rect x="20" y="38.5" width="8" height="3" rx="1.5" fill="#445771" />
      <path
        d="M24 1v2M8 18H6M42 18h-2M12 7l1.5 1.5M36 7l-1.5 1.5"
        stroke="#FFC94D"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function FeuerwehrIcon(): JSX.Element {
  return (
    <svg width="44" height="44" viewBox="0 0 48 48" aria-hidden="true">
      <rect x="7" y="13" width="22" height="4" rx="1" fill="#FFC94D" />
      <path d="M9 13v4M14 13v4M19 13v4M24 13v4" stroke="#B5793A" strokeWidth="1.2" />
      <rect x="4" y="19" width="28" height="15" rx="2" fill="#E4572E" />
      <path d="M32 23h7l5 6v5H32z" fill="#E4572E" />
      <rect x="34" y="24.5" width="5" height="4.5" rx="1" fill="#BFE0FF" />
      <rect x="35" y="19" width="5" height="3" rx="1" fill="#7DB9FF" />
      <circle cx="12" cy="36" r="4.5" fill="#0A2342" />
      <circle cx="12" cy="36" r="1.7" fill="#FFFFFF" />
      <circle cx="36" cy="36" r="4.5" fill="#0A2342" />
      <circle cx="36" cy="36" r="1.7" fill="#FFFFFF" />
    </svg>
  );
}

function WeltraumIcon(): JSX.Element {
  return (
    <svg width="44" height="44" viewBox="0 0 48 48" aria-hidden="true">
      <circle cx="8" cy="10" r="1.6" fill="#FFC94D" />
      <circle cx="40" cy="14" r="1.6" fill="#FFC94D" />
      <circle cx="38" cy="36" r="1.2" fill="#7DB9FF" />
      <path d="M19 30h10l-2 8-3 6-3-6z" fill="#FFC94D" />
      <path d="M16 21l-6 8 6 1zM32 21l6 8-6 1z" fill="#E4572E" />
      <path
        d="M24 3c7 5 9 13 8 24H16c-1-11 1-19 8-24z"
        fill="#F2F5FA"
        stroke="#0A2342"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle cx="24" cy="15" r="4" fill="#7DB9FF" stroke="#0A2342" strokeWidth="1.5" />
    </svg>
  );
}

function PiratenIcon(): JSX.Element {
  return (
    <svg width="44" height="44" viewBox="0 0 48 48" aria-hidden="true">
      <path d="M2 39c4-3 8-3 11 0s8 3 11 0 8-3 11 0 8 3 11 0v7H2z" fill="#7DB9FF" />
      <path d="M7 31h34l-6 8H13z" fill="#B5793A" />
      <rect x="23" y="7" width="2" height="24" fill="#5C3B1E" />
      <path
        d="M25 9c8 3 10 10 9 18h-9z"
        fill="#FFF4DE"
        stroke="#0A2342"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M23 12c-6 3-9 9-8 15h8z"
        fill="#FFF4DE"
        stroke="#0A2342"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path d="M25 3h8l-2 2.5 2 2.5h-8z" fill="#0A2342" />
    </svg>
  );
}

function SuperheldenIcon(): JSX.Element {
  return (
    <svg width="44" height="44" viewBox="0 0 48 48" aria-hidden="true">
      <path d="M13 14h22l5 28H8z" fill="#E4572E" />
      <circle cx="24" cy="20" r="11" fill="#0A2342" />
      <path
        d="M24 12.5l2.4 4.9 5.4.8-3.9 3.8.9 5.3-4.8-2.5-4.8 2.5.9-5.3-3.9-3.8 5.4-.8z"
        fill="#FFC94D"
      />
    </svg>
  );
}

function PolizeiIcon(): JSX.Element {
  return (
    <svg width="44" height="44" viewBox="0 0 48 48" aria-hidden="true">
      <rect x="18" y="13" width="6" height="5" rx="1" fill="#E4572E" />
      <rect x="24" y="13" width="6" height="5" rx="1" fill="#2F6FD6" />
      <path d="M5 29l5-10h24l7 10h3v8H5z" fill="#2F6FD6" />
      <path d="M12 21h8v7h-11zM22 21h10l5 7H22z" fill="#E3EFFF" />
      <rect x="5" y="31" width="39" height="3" fill="#FFFFFF" />
      <circle cx="14" cy="37" r="4.5" fill="#0A2342" />
      <circle cx="14" cy="37" r="1.7" fill="#FFFFFF" />
      <circle cx="35" cy="37" r="4.5" fill="#0A2342" />
      <circle cx="35" cy="37" r="1.7" fill="#FFFFFF" />
    </svg>
  );
}

function ZauberwaldIcon(): JSX.Element {
  return (
    <svg width="44" height="44" viewBox="0 0 48 48" aria-hidden="true">
      <path d="M14 4l9 14h-5l7 11H3l7-11H5z" fill="#5DBB63" />
      <rect x="12" y="29" width="4" height="9" fill="#8A5A2B" />
      <path d="M35 11l7 11h-4l5 8H27l5-8h-4z" fill="#3E9A4A" />
      <rect x="33" y="30" width="4" height="8" fill="#8A5A2B" />
      <path d="M19 42c0-4 3-6 6-6s6 2 6 6z" fill="#E4572E" />
      <circle cx="23" cy="39.5" r="1" fill="#FFFFFF" />
      <circle cx="27.5" cy="38.8" r="1" fill="#FFFFFF" />
      <rect x="23.5" y="42" width="3" height="4" fill="#FFF4DE" />
      <path d="M40 2l1 2.5 2.5 1-2.5 1-1 2.5-1-2.5-2.5-1 2.5-1z" fill="#FFC94D" />
      <path d="M26 6l.7 1.7 1.7.7-1.7.7L26 10.8l-.7-1.7-1.7-.7 1.7-.7z" fill="#FFC94D" />
    </svg>
  );
}

function DinoIcon(): JSX.Element {
  return (
    <svg width="44" height="44" viewBox="0 0 48 48" aria-hidden="true">
      <path d="M13 23l2-5 3 4zM19 21l2-5 3 4zM25 20l2-5 2.5 4.5z" fill="#3E9A4A" />
      <path
        d="M6 33c0-7 6-12 14-12 3 0 5-3 6-7 1-3 4-6 8-6 3.5 0 6 2 6 4.5S37.5 16 34.5 16c-2 0-3 2-3 5 0 3 4 6 4 12v6h-4v-5h-4v5h-4v-5h-6v5h-4v-5c-3 1-5.5 1-7.5-1z"
        fill="#5DBB63"
      />
      <circle cx="35.5" cy="11.5" r="1.4" fill="#0A2342" />
    </svg>
  );
}

function UnterwasserIcon(): JSX.Element {
  return (
    <svg width="44" height="44" viewBox="0 0 48 48" aria-hidden="true">
      <path
        d="M8 46c-3-5 3-9 0-15M41 46c3-5-3-9 0-15"
        stroke="#3E9A4A"
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
      />
      <path d="M9 24c5-9 18-9 23 0-5 9-18 9-23 0z" fill="#FF9F43" />
      <path d="M31 24l9-7v14z" fill="#FF9F43" />
      <path d="M18 17c2 3 2 11 0 14" stroke="#E4572E" strokeWidth="1.5" fill="none" />
      <circle cx="14.5" cy="22" r="1.7" fill="#0A2342" />
      <circle cx="22" cy="9" r="2.2" fill="none" stroke="#7DB9FF" strokeWidth="1.5" />
      <circle cx="27" cy="4.5" r="1.6" fill="none" stroke="#7DB9FF" strokeWidth="1.5" />
    </svg>
  );
}

export function TilePictogram({ slug }: { slug: ErfundenTileSlug }): JSX.Element {
  switch (slug) {
    case 'feuerwehr':
      return <FeuerwehrIcon />;
    case 'weltraum':
      return <WeltraumIcon />;
    case 'piraten':
      return <PiratenIcon />;
    case 'superhelden':
      return <SuperheldenIcon />;
    case 'polizei':
      return <PolizeiIcon />;
    case 'zauberwald':
      return <ZauberwaldIcon />;
    case 'dino':
      return <DinoIcon />;
    case 'unterwasser':
      return <UnterwasserIcon />;
    case 'eigene':
      return <EigeneIdeeIcon />;
  }
}

export function ChevronIcon({ open }: { open: boolean }): JSX.Element {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#0A2342"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{
        transition: 'transform .15s',
        transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
        flex: '0 0 18px',
        marginTop: '2px',
      }}
    >
      <path d="M9 6l6 6-6 6" />
    </svg>
  );
}

export function MicrophoneIcon(): JSX.Element {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#445771"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="9" y="3" width="6" height="11" rx="3" />
      <path d="M5 11a7 7 0 0 0 14 0M12 18v3" />
    </svg>
  );
}
